let mockBreakDurations = [
  {
    id: 1,
    nameEnglish: 'Lunch Break',
    nameArabic: 'استراحة الغداء',
    code: '001',
    startTime: '13:00',
    endTime: '13:30',
    duration: 30,
  },
  {
    id: 2,
    nameEnglish: 'Tea Break',
    nameArabic: 'استراحة الشاي',
    code: 'TEA',
    startTime: '16:00',
    endTime: '16:15',
    duration: 15,
  },
  {
    id: 3,
    nameEnglish: 'Coffee Break',
    nameArabic: 'استراحة القهوة',
    code: 'COFFEE',
    startTime: '10:30',
    endTime: '10:45',
    duration: 15,
  },
  {
    id: 4,
    nameEnglish: 'Prayer Break',
    nameArabic: 'استراحة الصلاة',
    code: 'PRAYER',
    startTime: '12:00',
    endTime: '12:20',
    duration: 20,
  },
  {
    id: 5,
    nameEnglish: 'Morning Break',
    nameArabic: 'استراحة الصباح',
    code: 'MORNING',
    startTime: '09:30',
    endTime: '09:45',
    duration: 15,
  },
  {
    id: 6,
    nameEnglish: 'Afternoon Break',
    nameArabic: 'استراحة بعد الظهر',
    code: 'AFTERNOON',
    startTime: '15:00',
    endTime: '15:20',
    duration: 20,
  },
  {
    id: 7,
    nameEnglish: 'Evening Break',
    nameArabic: 'استراحة المساء',
    code: 'EVENING',
    startTime: '17:30',
    endTime: '17:45',
    duration: 15,
  },
  {
    id: 8,
    nameEnglish: 'Snack Break',
    nameArabic: 'استراحة خفيفة',
    code: 'SNACK',
    startTime: '11:00',
    endTime: '11:15',
    duration: 15,
  },
  {
    id: 9,
    nameEnglish: 'Short Rest',
    nameArabic: 'راحة قصيرة',
    code: 'REST1',
    startTime: '14:30',
    endTime: '14:40',
    duration: 10,
  },
  {
    id: 10,
    nameEnglish: 'Quick Break',
    nameArabic: 'استراحة سريعة',
    code: 'QUICK',
    startTime: '16:45',
    endTime: '17:00',
    duration: 15,
  },
  {
    id: 11,
    nameEnglish: 'Power Nap',
    nameArabic: 'غفوة قصيرة',
    code: 'NAP',
    startTime: '14:00',
    endTime: '14:20',
    duration: 20,
  },
  {
    id: 12,
    nameEnglish: 'Health Break',
    nameArabic: 'استراحة صحية',
    code: 'HEALTH',
    startTime: '10:00',
    endTime: '10:15',
    duration: 15,
  },
  {
    id: 13,
    nameEnglish: 'Stretch Break',
    nameArabic: 'استراحة التمدد',
    code: 'STRETCH',
    startTime: '11:45',
    endTime: '12:00',
    duration: 15,
  },
  {
    id: 14,
    nameEnglish: 'Smoke Break',
    nameArabic: 'استراحة تدخين',
    code: 'SMOKE',
    startTime: '15:45',
    endTime: '16:00',
    duration: 15,
  },
  {
    id: 15,
    nameEnglish: 'Chai Break',
    nameArabic: 'استراحة الشاي الهندي',
    code: 'CHAI',
    startTime: '17:15',
    endTime: '17:30',
    duration: 15,
  },
  {
    id: 16,
    nameEnglish: 'Mental Break',
    nameArabic: 'استراحة عقلية',
    code: 'MENTAL',
    startTime: '11:15',
    endTime: '11:30',
    duration: 15,
  },
  {
    id: 17,
    nameEnglish: 'Cooling Break',
    nameArabic: 'استراحة التبريد',
    code: 'COOL',
    startTime: '12:30',
    endTime: '12:45',
    duration: 15,
  },
  {
    id: 18,
    nameEnglish: 'Water Break',
    nameArabic: 'استراحة الماء',
    code: 'WATER',
    startTime: '09:15',
    endTime: '09:25',
    duration: 10,
  },
  {
    id: 19,
    nameEnglish: 'Late Lunch',
    nameArabic: 'غداء متأخر',
    code: 'LLUNCH',
    startTime: '14:00',
    endTime: '14:30',
    duration: 30,
  },
  {
    id: 20,
    nameEnglish: 'Early Break',
    nameArabic: 'استراحة مبكرة',
    code: 'EARLY',
    startTime: '08:30',
    endTime: '08:45',
    duration: 15,
  },
];

let idCounter = 21;

const BreakDurationAPI = {
  getAll: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        // resolve({ data: { data: [...mockBreakDurations].reverse() } });
        resolve({ data: { data: [...mockBreakDurations] } });
      }, 300);
    });
  },

  add: async (newData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: idCounter++ };
        // mockBreakDurations.push(newItem);
        mockBreakDurations = [...mockBreakDurations, newItem];

        resolve({ data: { data: newItem } });
      }, 300);
    });
  },

  update: async (id, updatedData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockBreakDurations.findIndex((item) => item.id === id);
        if (index !== -1) {
          // mockBreakDurations[index] = { ...updatedData };
          mockBreakDurations[index] = {
            ...mockBreakDurations[index],
            ...updatedData,
          };

          resolve({ data: { data: mockBreakDurations[index] } });
        }
      }, 300);
    });
  },

  delete: async (ids) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        // Convert single ID to array if needed
        const idsToDelete = Array.isArray(ids) ? ids : [ids];

        // Filter out the items to be deleted
        const initialLength = mockBreakDurations.length;
        mockBreakDurations = mockBreakDurations.filter(
          (item) => !idsToDelete.includes(item.id)
        );

        resolve({
          status: 200,
          data: {
            deletedCount: idsToDelete.length,
            deletedIds: idsToDelete,
          },
        });
      }, 300);
    });
  },
};

export default BreakDurationAPI;



// import { getCompanyID } from '@/helpers/Utils';
// import { Post ,Get , Put, Delete} from '@/api/api-middleware';
// import { apiPath } from '@/constants/defaultValues';

// // Operator constants for better readability
// export const OPERATORS = {
//   CONTAINS: 1,
//   STARTS_WITH: 2,
//   ENDS_WITH: 3,
//   EQUALS: 4,
//   NOT_EQUALS: 5,
//   GREATER_THAN: 6,
//   GREATER_THAN_EQUAL: 7,
//   LESS_THAN: 8,
//   LESS_THAN_EQUAL: 9,
//   BETWEEN: 10,
//   IN: 11,
//   NOT_IN: 12,
//   IS_NULL: 13,
//   IS_NOT_NULL: 14
// };

// const BreakDurationAPI = {
//   getAll: async (params = {}) => {
//     try {
//       const requestBody = {
//         conditions: params.conditions || [],
//         sortColumn: params.sortColumn || "",
//         sortDirection: params.sortDirection || "",
//         skip: params.skip || 0,
//         take: params.take || 100,
//         companyID: getCompanyID()
//       };

//       console.log('Break Definition Request:', requestBody);

//       const response = await Post({
//         url: `${apiPath}api/break-definition/get-all`,
//         data: requestBody
//       });
      
//       return response;
//     } catch (error) {
//       console.error('Break Definition API Error:', error);
//       throw error;
//     }
//   },

//   getById: async (id) => {
//     try {
//       const requestBody = {
//         conditions: [
//           {
//             column: "ID", // Adjust based on your API's ID field name
//             operator: OPERATORS.EQUALS,
//             value: id,
//             value2: "",
//             values: []
//           }
//         ],
//         sortColumn: "",
//         sortDirection: "",
//         skip: 0,
//         take: 1,
//         companyID: getCompanyID()
//       };

//       const response = await Post({
//         url: `${apiPath}api/break-definition/get-all`,
//         data: requestBody
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   add: async (payload) => {
//     try {
//       const response = await Post({
//         url: `${apiPath}api/break-definition/add`,
//         data: {
//           ...payload,
//           companyID: getCompanyID()
//         },
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   update: async (id, payload) => {
//     try {
//       const response = await Put({
//         url: `${apiPath}api/break-definition/update/${id}`,
//         data: {
//           ...payload,
//           companyID: getCompanyID()
//         },
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   delete: async (ids) => {
//     try {
//       if (Array.isArray(ids)) {
//         const deletePromises = ids.map(id => 
//           Delete({
//             url: `${apiPath}api/break-definition/delete/${id}`,
//           })
//         );
//         return await Promise.all(deletePromises);
//       } else {
//         const response = await Delete({
//           url: `${apiPath}api/break-definition/delete/${ids}`,
//         });
//         return response;
//       }
//     } catch (error) {
//       throw error;
//     }
//   }
// };

// export default BreakDurationAPI;
